function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
}

function countdownVisibility(today, schedule, deadline) {
  let visibility = true;
  let weekend = false;

  // Check if it's a weekend
  if (today.getDay() === 0 || today.getDay() === 6) {
    weekend = true;
  }

  // Get today's short date
  const ye = new Intl.DateTimeFormat("en", {year: "numeric"}).format(today);
  const mo = new Intl.DateTimeFormat("en", {month: "2-digit"}).format(today);
  const da = new Intl.DateTimeFormat("en", {day: "2-digit"}).format(today);
  const shortToday = `${da}/${mo}/${ye}`;

  // Set deadline time for weekdays and weekends
  const currentTimeMilliseconds = new Date(today).getTime();

  // If today is in the schedule of holidays, then hide the countdown
  if (schedule.includes(shortToday)) {
    visibility = false;
  } else {
    // For weekends, check visibility
    if (weekend) {
      const weekendCutoff = new Date(today);
      weekendCutoff.setHours(15, 0, 0, 0); // 3 PM cutoff
      if (currentTimeMilliseconds > weekendCutoff.getTime()) {
        visibility = false;
      }
    } else {
      // For weekdays, check visibility against 10 PM
      const weekdayCutoff = new Date(today);
      weekdayCutoff.setHours(22, 0, 0, 0); // 10 PM cutoff
      if (currentTimeMilliseconds > weekdayCutoff.getTime()) {
        visibility = false;
      }
    }
  }

  return visibility;
}

function initializeClock(el, deadline, schedule, today) {
  const visibility = countdownVisibility(today, schedule, deadline);

  // Completely hide if it's gone past the cutoff point
  if (!visibility) {
    el.style.display = "none";
    return; // Stop further execution if element should be hidden
  }

  const timeinterval = setInterval(() => {
    const t = getTimeRemaining(deadline);
    const output = el.querySelector("span.countdown-js");

    if (t.total <= 0) {
      clearInterval(timeinterval); // Stop the countdown once it's passed the cutoff
      el.style.display = "none"; // Hide the element if the time has passed
    } else {
      output.innerHTML =
        "Order in " +
        t.hours +
        " hours " +
        t.minutes +
        " minutes and " +
        t.seconds +
        " seconds";
    }
  }, 1000);
}

export default function () {
  const url = window.location.href;

  if (url.includes("/products/")) {
    // WHERE TO PLACE THE COUNTDOWN dahs
    const clock = document.querySelector('[data-countdown="active"]');

    // IF CLOCK SPAN EXISTS, INITIALIZE THE CLOCK
    if (clock) {
      // GET SCHEDULE FROM ATTRIBUTES
      let schedule = clock.getAttribute("data-holidays");
      schedule = schedule.split(",");

      // CREATE DEADLINE
      const today = new Date();
      let deadline;

      // Check if today is Saturday or Sunday
      const day = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

      if (day === 0 || day === 6) {
        // Weekend
        // Set cutoff for weekend at 3 PM
        deadline = new Date(today.setHours(15, 0, 0, 0));
      } else {
        // Weekdays
        // Set cutoff for weekdays at 10 PM
        deadline = new Date(today.setHours(22, 0, 0, 0));
      }

      // Adjust deadline to the next day if the current time has passed the cutoff
      if (today > deadline) {
        deadline.setDate(deadline.getDate() + 1); // Move to next day
      }

      // INIT CLOCK
      initializeClock(clock, deadline, schedule, today);
    }
  }
}

/*

  _________________________
< YEEHAW >
  -------------------------
     >>\.
    /_  )`.
   /  _)`^)`.   _.---. _
  (_,' \  `^-)""      `.\
        |              | \
        \              / |
       / \  /.___.'\  (\ (_
      < ,"||     \ |`. \`-'
       \\ ()      )|  )/
       |_>|>     /_] //
         /_]        /_]

*/
